import { type Action, type Reducer, combineReducers } from 'redux'

import agenticBuilderReducer from './slices/agenticBuilderSlice'
import { reduxApi } from './slices/apiSlice'
import authReducer from './slices/authSlice'
import expressionBuilderReducer from './slices/expressionBuilderSlice'
import formNodesReducer from './slices/formNodesSlice'
import modalReducer from './slices/modalSlice'
import organizationReducer from './slices/organizationSlice'
import processEditReducer from './slices/processEditSlice'

export interface AppState {
  agenticBuilder: ReturnType<typeof agenticBuilderReducer>
  auth: ReturnType<typeof authReducer>
  modal: ReturnType<typeof modalReducer>
  organization: ReturnType<typeof organizationReducer>
  formNodes: ReturnType<typeof formNodesReducer>
  expressionBuilder: ReturnType<typeof expressionBuilderReducer>
  processEdit: ReturnType<typeof processEditReducer>
  api: ReturnType<typeof reduxApi.reducer>
}

const appReducer = combineReducers({
  agenticBuilder: agenticBuilderReducer,
  auth: authReducer,
  modal: modalReducer,
  organization: organizationReducer,
  formNodes: formNodesReducer,
  expressionBuilder: expressionBuilderReducer,
  processEdit: processEditReducer,
  api: reduxApi.reducer,
})

const rootReducer: Reducer<AppState | undefined, Action> = (state, action) => {
  if (action.type === 'RESET_STATE') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
